import { render } from "./PersianNumberField.vue?vue&type=template&id=2d7f4ef4"
import script from "./PersianNumberField.vue?vue&type=script&lang=js"
export * from "./PersianNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianNumberField.vue"]])

export default __exports__